import React from "react"
import classNames from "classnames"

import CustomSelect from "../tailwind/CustomSelect"

interface IQuantityProps {
  loading?: boolean
  disabled?: boolean
  onChange: (value: any) => void
  label?: string
  [x: string]: any
}

const Quantity: React.FC<IQuantityProps> = ({ value, onChange, className }) => {
  return (
    <div
      className={classNames(
        "my-4 mr-4 flex min-w-[100px] items-center",
        className
      )}
    >
      <CustomSelect
        name="quantity"
        labelClassName="mr-2 text-color-darkGrey"
        optionsClassName="w-[70px]"
        label="Quantity"
        options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}
export default Quantity
